import { isEmpty, get } from "lodash";
import USER_TYPE_CONSTANTS from "@/constants/user";
import store from "../store";

// Initializing orgId or vendorId
const initLocalStorageDetails = async ({ isVendorView, userType, decodedToken }) => {
  if (userType === USER_TYPE_CONSTANTS.organizationUser && !isVendorView) {
    // This is the org id of the current login, this is for security purpose
    // We always used decoded token to avoid using localStorage when they tamper the orgId
    const currentLogginOrgId = get(decodedToken.sim.details, "id", null);
    if (isEmpty(localStorage.orgId)) {
      localStorage.setItem("orgId", currentLogginOrgId);
    }
  } else if (userType === USER_TYPE_CONSTANTS.vendorUser) {
    const vendorId = get(decodedToken.sim.details, "id", "");
    if (isEmpty(localStorage.selected_vendor)) {
      localStorage.setItem("selected_vendor", vendorId);
    }
  }
};

const fetchOrgInitialDetails = async ({ userType, isSimpatraSuperAdmin }) => {
  const orgDetails = store.getters["accountsModule/getOrgDetails"];
  const isEmptyOrgDetails = isEmpty(orgDetails) || isEmpty(orgDetails.id);
  const organizationUser = userType === USER_TYPE_CONSTANTS.organizationUser;
  if (isEmptyOrgDetails && organizationUser) {
    const orgId = localStorage.getItem("orgId");
    let selectedLocation = localStorage.getItem("currentLocation");
    const locationIsEmpty = ["", null, undefined].includes(selectedLocation);

    const fetchAccessibleLocationQueryParams = isSimpatraSuperAdmin ? { orgId } : {};
    const userAccessibleLocations = await store.dispatch("usersModule/fetchLoggedUserAccessibleLocations", fetchAccessibleLocationQueryParams);
    const currentUserAvailableLocations = userAccessibleLocations && userAccessibleLocations.locations ? userAccessibleLocations.locations : [];
    const userActiveLocations = currentUserAvailableLocations.length > 0 ? currentUserAvailableLocations.filter(item => item.isActive === true) : null;

    const isLocationExist = currentUserAvailableLocations.find(item => item.id === selectedLocation);
    selectedLocation = isEmpty(isLocationExist) || locationIsEmpty ? userActiveLocations[0]?.id : selectedLocation;
    localStorage.setItem("currentLocation", selectedLocation);

    // FETCHING DETAILS OF SPECIFIC LOCATION OF AN ORGANIZATION
    const currentLocationDetails = await store.dispatch("locationsModule/fetchLocationDetails", {
      locationId: selectedLocation,
    });
    store.commit("locationsModule/setCurrentLocationDetails", currentLocationDetails); // SETTING CURRENT PAGE
    store.commit("locationsModule/setCurrentUserAvailableLocation", currentUserAvailableLocations);

    await store.dispatch("accountsModule/fetchOrgDetails", { orgId });
    store.commit("locationsModule/setSelectedCurrentLocation", selectedLocation, { root: true });
    return {
      orgId,
      selectedLocation,
    };
  }
  return null;
};

const initializeUserRoles = async userId => {
  const userRoles = store.getters["usersModule/getMyRolesAndPermissions"];
  if (!userRoles || userRoles.length === 0) {
    const accessRightsResponse = await store.dispatch("rolesAndPermissionsModule/fetchUserAccessRights", { userId, isUsersData: true });
    if (accessRightsResponse && accessRightsResponse.accessRights) {
      store.commit("usersModule/setCurrentUserRolesAndPermission", accessRightsResponse.accessRights);
    }
  }
};

export default {
  initLocalStorageDetails,
  fetchOrgInitialDetails,
  initializeUserRoles,
};
